import { NavLink } from 'react-router-dom';
import {
  HiOutlineDocumentReport,
  HiOutlineChartBar,
  HiOutlineCog,
  HiOutlineChevronLeft,
  HiOutlineChevronRight,
  HiOutlineViewGrid,
  HiOutlineUserGroup,
  HiOutlineCalculator,
  HiOutlineLightningBolt,
} from 'react-icons/hi';

const menuItems = [
  { path: '/analysis', label: 'Analysis', Icon: HiOutlineChartBar },
  { path: '/playground', label: 'Playground', Icon: HiOutlineLightningBolt },
  { path: '/daily-report', label: 'Daily Report', Icon: HiOutlineDocumentReport },
  { path: '/finance-simulator', label: 'Finance Simulator', Icon: HiOutlineCalculator },
  { path: '/settings', label: 'Settings', Icon: HiOutlineCog },
];

const adminMenuItems = [
  { path: '/admin/watchlists', label: 'Watchlists', Icon: HiOutlineViewGrid },
  { path: '/admin/configurations', label: 'Configurations', Icon: HiOutlineCog },
  { path: '/admin/users', label: 'Users', Icon: HiOutlineUserGroup },
];

function Sidebar({ isAdmin, collapsed, onCollapsedChange }) {
  return (
    <aside className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''}`}>
      <nav className="sidebar-nav" aria-label="Main">
        <ul className="sidebar-menu">
          {menuItems.map(({ path, label, Icon }) => (
            <li key={path}>
              <NavLink
                to={path}
                className={({ isActive }) =>
                  `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
                }
                end={path === '/analysis'}
                title={collapsed ? label : undefined}
              >
                <Icon className="sidebar-icon" aria-hidden />
                <span className="sidebar-link-text">{label}</span>
              </NavLink>
            </li>
          ))}
          {isAdmin && (
            <>
              <li className="sidebar-divider" aria-hidden="true" />
              <li className="sidebar-admin-label" aria-hidden="true">
                Admin
              </li>
              {adminMenuItems.map(({ path, label, Icon }) => (
                <li key={path} className="sidebar-menu-item--admin">
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
                    }
                    title={collapsed ? label : undefined}
                  >
                    <Icon className="sidebar-icon" aria-hidden />
                    <span className="sidebar-link-text">{label}</span>
                  </NavLink>
                </li>
              ))}
            </>
          )}
        </ul>
        <div className="sidebar-footer">
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => onCollapsedChange(!collapsed)}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? (
              <HiOutlineChevronRight className="sidebar-toggle-icon" aria-hidden />
            ) : (
              <HiOutlineChevronLeft className="sidebar-toggle-icon" aria-hidden />
            )}
          </button>
        </div>
      </nav>
    </aside>
  );
}

export default Sidebar;
